<script lang="ts" setup>
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { inAppReviewService } from "@/app/services/InAppReviewService";
import { orderService } from "@/app/services/OrderService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import RecentOrders from "@/components/molecules/orders/RecentOrders.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { orderStore } from "@/store/order";
import { Order } from "@/types/order/Order";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";

const errorModal = useErrorModal();
const loader = useLoader();
const router = useRouter();

const orders = ref<Order[]>([]);
const applicableOrderCount = ref(0);

onMounted(async () => {
  await inAppReviewService.launchInAppReview("APPLY_ORDER");
});

onBeforeMount(async () => {
  try {
    loader.show();
    await fetchEachDayOrders();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const mascotImage = computed(() =>
  require("@/assets/svg/caikuma_send_message" +
    authStore.productAssetSuffix +
    ".svg")
);
const selectedOrder = computed(() => orderStore.orderDetail);

function onClickBack() {
  router.go(-6);
}
async function fetchEachDayOrders() {
  const { results, count } = await orderService.fetchOrdersEachDayWithCount({
    office: selectedOrder.value!.office.id,
    serviceName: authStore.workerService.serviceName,
    onlyHiring: true
  });
  orders.value = results;
  applicableOrderCount.value = count;
}
</script>

<template>
  <Header>
    <template v-slot:left>
      <FeatherIcon icon="chevron-left" @click="onClickBack" />
    </template>
    申し込み完了
  </Header>

  <div>
    <div
      class="d-flex align-items-center justify-content-center flex-column mt-2 mb-4"
    >
      <img width="114" :src="mascotImage" />
      <div class="mt-2 text-black text-weight-600 text-center">
        お仕事の準備が完了しました<br />
        勤務当日のご活躍を応援しています！
      </div>
    </div>
    <RecentOrders
      title="この事業所様の他のお仕事"
      titleClass="recent-orders-title"
      class="px-3 py-3"
      :currentOrder="selectedOrder"
      :orders="orders"
      :applicableOrderCount="applicableOrderCount"
    />
    <div class="mt-2 mx-3 mb-4">
      <AppButton class="w-100 mt-2" :to="{ name: 'Search' }"
        >引き続き他の仕事を探す</AppButton
      >
    </div>
  </div>
  <AppFooter />
  <BlockBack />
</template>

<style lang="scss" scoped>
:deep(.recent-orders-title) {
  color: $mild !important;
}
</style>
